/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionFlowConfigDto } from './SubscriptionFlowConfigDto';
import {
    SubscriptionFlowConfigDtoFromJSON,
    SubscriptionFlowConfigDtoFromJSONTyped,
    SubscriptionFlowConfigDtoToJSON,
    SubscriptionFlowConfigDtoToJSONTyped,
} from './SubscriptionFlowConfigDto';

/**
 * 
 * @export
 * @interface MembershipAffiliationDto
 */
export interface MembershipAffiliationDto {
    /**
     * 
     * @type {string}
     * @memberof MembershipAffiliationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MembershipAffiliationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MembershipAffiliationDto
     */
    abbreviation: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MembershipAffiliationDto
     */
    allowedLoginMethods: Array<MembershipAffiliationDtoAllowedLoginMethodsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof MembershipAffiliationDto
     */
    acceptingNewSubscribers: boolean;
    /**
     * 
     * @type {SubscriptionFlowConfigDto}
     * @memberof MembershipAffiliationDto
     */
    subscriptionFlowConfig: SubscriptionFlowConfigDto;
}


/**
 * @export
 */
export const MembershipAffiliationDtoAllowedLoginMethodsEnum = {
    Email: 'email',
    Sso: 'sso',
    MlsSso: 'mls-sso'
} as const;
export type MembershipAffiliationDtoAllowedLoginMethodsEnum = typeof MembershipAffiliationDtoAllowedLoginMethodsEnum[keyof typeof MembershipAffiliationDtoAllowedLoginMethodsEnum];


/**
 * Check if a given object implements the MembershipAffiliationDto interface.
 */
export function instanceOfMembershipAffiliationDto(value: object): value is MembershipAffiliationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined) return false;
    if (!('allowedLoginMethods' in value) || value['allowedLoginMethods'] === undefined) return false;
    if (!('acceptingNewSubscribers' in value) || value['acceptingNewSubscribers'] === undefined) return false;
    if (!('subscriptionFlowConfig' in value) || value['subscriptionFlowConfig'] === undefined) return false;
    return true;
}

export function MembershipAffiliationDtoFromJSON(json: any): MembershipAffiliationDto {
    return MembershipAffiliationDtoFromJSONTyped(json, false);
}

export function MembershipAffiliationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipAffiliationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
        'allowedLoginMethods': json['allowedLoginMethods'],
        'acceptingNewSubscribers': json['acceptingNewSubscribers'],
        'subscriptionFlowConfig': SubscriptionFlowConfigDtoFromJSON(json['subscriptionFlowConfig']),
    };
}

export function MembershipAffiliationDtoToJSON(json: any): MembershipAffiliationDto {
    return MembershipAffiliationDtoToJSONTyped(json, false);
}

export function MembershipAffiliationDtoToJSONTyped(value?: MembershipAffiliationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
        'allowedLoginMethods': value['allowedLoginMethods'],
        'acceptingNewSubscribers': value['acceptingNewSubscribers'],
        'subscriptionFlowConfig': SubscriptionFlowConfigDtoToJSON(value['subscriptionFlowConfig']),
    };
}

